export function boardInsertionIndex(pointerY: number, cardMidpoints: number[]): number {
  const index = cardMidpoints.findIndex(midpoint => pointerY < midpoint);
  return index < 0 ? cardMidpoints.length : index;
}
